module.exports = __webpack_public_path__ + "media/images/front/event/inner-link-1fe7380fe7c0e4bfd7e207a04dd8d166.svg";